import React from 'react';
import '../patients/PatientsGrid.css';
import './LaboratoryOrdersGrid.css';

const LaboratoryOrdersGrid = ({
  orders,
  timezone,
  manualStatusOptions,
  getDisplayStatus,
  formatLaboratoryDate,
  onEdit,
  onStatusChange,
  onCancel,
  onUpload,
  uploadingOrderId
}) => {
  return (
    <div className="patients-grid-container laboratory-orders-grid-container">
      <div className="patients-grid laboratory-orders-grid">
        {orders.map((order) => {
          const displayStatus = getDisplayStatus(order, timezone);

          return (
            <div key={order.id} className="patient-card laboratory-order-card" onClick={() => onEdit(order)}>
              <div className="patient-card-content laboratory-order-card-content">
                <div className="patient-main-info laboratory-order-main-info">
                  <div className="patient-info laboratory-order-info">
                    <h3 className="patient-name laboratory-order-name">{order.patientName || 'Sin paciente'}</h3>
                    <div className="patient-contact laboratory-order-contact">
                      <select
                        value={order.status}
                        onClick={(event) => event.stopPropagation()}
                        onChange={(event) => onStatusChange(order.id, event.target.value)}
                        className={`status-select laboratory-status-select ${displayStatus}`}
                        aria-label={`Estado de la orden de ${order.patientName || 'laboratorio'}`}
                      >
                        {manualStatusOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="action-indicator">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                </div>

                <div className="patient-details-compact laboratory-order-details">
                  <div className="detail-row">
                    <div className="detail-item-compact occupation">
                      <i className="fas fa-tooth detail-icon"></i>
                      <span className="detail-value">{order.workType || '-'}</span>
                    </div>
                  </div>
                  <div className="detail-row">
                    <div className="detail-item-compact">
                      <i className="fas fa-user-md detail-icon"></i>
                      <span className="detail-value">{order.doctorName || '-'}</span>
                    </div>
                    <div className="detail-item-compact">
                      <i className="fas fa-truck detail-icon"></i>
                      <span className="detail-value">{order.providerName || '-'}</span>
                    </div>
                  </div>
                  <div className="detail-row">
                    <div className="detail-item-compact">
                      <i className="fas fa-calendar detail-icon"></i>
                      <span className="detail-value">{formatLaboratoryDate(order.requestedDeliveryDate, timezone)}</span>
                    </div>
                  </div>
                </div>

                <div className="laboratory-order-card-actions" onClick={(event) => event.stopPropagation()}>
                  <div className="laboratory-order-card-buttons">
                    <button
                      type="button"
                      className="btn btn-primary btn-icon btn-sm"
                      onClick={() => onEdit(order)}
                      title="Editar"
                      aria-label="Editar"
                    >
                      <i className="fas fa-pen"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger btn-icon btn-sm"
                      onClick={() => onCancel(order)}
                      disabled={order.status === 'cancelled'}
                      title="Cancelar"
                      aria-label="Cancelar"
                    >
                      <i className="fas fa-ban"></i>
                    </button>
                    <input
                      id={`order-upload-mobile-${order.id}`}
                      type="file"
                      multiple
                      onChange={(event) => onUpload(order.id, event)}
                      style={{ display: 'none' }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary btn-icon btn-sm"
                      onClick={() => document.getElementById(`order-upload-mobile-${order.id}`)?.click()}
                      disabled={uploadingOrderId === order.id}
                      title="Adjuntar archivo"
                      aria-label="Adjuntar archivo"
                    >
                      <i className={`fas ${uploadingOrderId === order.id ? 'fa-spinner fa-spin' : 'fa-paperclip'}`}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LaboratoryOrdersGrid;